module.exports = __webpack_public_path__ + "img/Fee.59cf204f.png";